import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SiAuthenticationService } from '@strategic-insights/ng-authentication';

@Injectable()
export class AuthTokenGuard implements CanActivate {

  constructor(private siAuthenticationService: SiAuthenticationService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.siAuthenticationService.getWebToken() || this.siAuthenticationService.getAuthToken()) {
      return new Observable<boolean>(observer => {
        this.siAuthenticationService.checkToken().subscribe(response => {
          observer.next(false);
          observer.complete();
        }, error => {
          observer.next(true);
          observer.complete();
        });
      });
    } else {
      return true;
    }
  }
}
